/**
 * g-plan feature の公開ルート定義
 *
 * `lib/middleware/route-registry.ts` から static import される。
 *
 * Edge Runtime 制約:
 * - 純定数 export のみ（関数呼び出し・副作用なし）
 *
 * @see docs/計画/2026-05-09-ICpochipochi-漏れ抽象化.md L-A3
 */

export const G_PLAN_PUBLIC_PATHS = {
  pages: [
    '/g-plans/check',
  ] as const,
  apis: [] as const,
} as const
